import { render } from "./BuyCryptoView.vue?vue&type=template&id=44d51462&scoped=true&ts=true"
import script from "./BuyCryptoView.vue?vue&type=script&lang=ts"
export * from "./BuyCryptoView.vue?vue&type=script&lang=ts"

import "./BuyCryptoView.vue?vue&type=style&index=0&id=44d51462&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d51462"],['__file',"src/views/BuyCryptoView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44d51462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44d51462', __exports__)) {
    api.reload('44d51462', __exports__)
  }
  
  module.hot.accept("./BuyCryptoView.vue?vue&type=template&id=44d51462&scoped=true&ts=true", () => {
    api.rerender('44d51462', render)
  })

}


export default __exports__